import { useMutation } from 'react-query';
import mutationPostLogin from './mutations/postLogin';
import mutationPostLogout from './mutations/postLogout';
import mutationForgottenPassword from './mutations/forgottenPassword';
import mutationLoginFromTotp from './mutations/loginFromTotp';


const actionsLogin = {
    postLogin: (onSuccess, onError) => useMutation(mutationPostLogin(onSuccess, onError)),
    postLogout: (onSuccess, onError) => useMutation(mutationPostLogout(onSuccess, onError)),
    forgottenPassword: (onSuccess, onError) => useMutation(mutationForgottenPassword(onSuccess, onError)),
    loginFromTotp: (onSuccess, onError) => useMutation(mutationLoginFromTotp(onSuccess, onError))
};

export default actionsLogin;